import { apiRegister } from '../utils/api'

/**
  1365	award2019/youpin	/award2020/dianjin/laxin/userlist/	获取用户的拉新用户列表	正常         
  1364	award2019/youpin	/award2020/dianjin/laxin/awardlist/	获取用户获得的活动码列表	正常	         
  1363	award2019/youpin	/award2020/dianjin/laxin/actcode/take/	领取活动码	正常	         
  1362	award2019/youpin	/award2020/dianjin/laxin/actcode/info/	获取活动券信息	正常	         
  1361	award2019/youpin	/award2020/dianjin/laxin/gactcodelist/	获取王者点金双11卡券资格发放列表	正常	         
 */

 // 1365	award2019/youpin	/award2020/dianjin/laxin/invitelist/	获取用户的拉新用户列表
export const laxinInviteList = apiRegister('laxinInviteList', {
  protoId: 1365,
  path: '/award2020/dianjin/laxin/invitelist/'
}).send

// 1364	award2019/youpin	/award2020/dianjin/laxin/awardlist/	获取用户获得的活动奖励列表	正常
export const laxinMyAwards = apiRegister('laxinMyAwards', {
  protoId: 1364,
  path: '/award2020/dianjin/laxin/awardlist/'
}).send

// 1362	award2019/youpin	/award2020/dianjin/laxin/actcode/info/	获取活动券信息	正常
export const laxinAwardInfo = apiRegister('laxinAwardInfo', {
  protoId: 1362,
  path: '/award2020/dianjin/laxin/awardinfo/'
}).send

// 1361	award2019/youpin	/award2020/dianjin/laxin/gawardlist/	获取王者点金双11卡券资格发放列表
export const laxinGiveAwards = apiRegister('laxinGiveAwards', {
  protoId: 1361,
  path: '/award2020/dianjin/laxin/gawardlist/'
}).send

// 1368	award2019/youpin	/award2020/dianjin/laxin/bind/	绑定邀请 关系
export const laxinBind = apiRegister('laxinBind', {
  protoId: 1368,
  path: '/award2020/dianjin/laxin/bind/'
}).send

// 1369	award2019/youpin	/award2020/dianjin/laxin/teaminfo/	获取被邀请新人组队信息
export const laxinTeamInfo = apiRegister('laxinTeamInfo', {
  protoId: 1369,
  path: '/award2020/dianjin/laxin/teaminfo/'
}).send

// 1372	award2019/youpin	/award2020/dianjin/laxin/shareinfo/	获取分享信息
export const laxinShareInfo = apiRegister('laxinShareInfo', {
  protoId: 1372,
  path: '/award2020/dianjin/laxin/shareinfo/'
}).send
